import React, { Component } from 'react';
export class BannerImg extends Component {

  render() {
    const { style, ...restProps  } = this.props;
    // const config = [
    //   {
    //     name: "Image",
    //     props: {
    //       size: 'large',
    //       src: imgUrl,
    //       params: href !== undefined && target !== undefined ? {
    //         url: href,
    //         target
    //       } : undefined,
    //       onClick: href !== undefined && target !== undefined ? 'openUrl' : undefined,
    //     },
    //   }
    // ];
    const customAttributes = {
    };
    //const Components = getChildren(children);
    return (<div
      {...restProps} {...customAttributes} style={style}>{this.props.children}</div>);
   }
}

export default BannerImg;

